import React from 'react'
import Env from '../../Env'

export interface DevelopmentOnlyAreaProps {
  children: React.ReactNode[] | React.ReactNode
}

export function DevelopmentOnlyArea(props: DevelopmentOnlyAreaProps) {
  return Env.SYSTEM_MODE === 'dev'
    ? <>{props.children}</>
    : <></>
}
